import * as React from "react";
import { Platform, SafeAreaView, ScrollView, StatusBar, StyleSheet, View } from "react-native";
import { Grid, Container, Row, Column } from "ui-grid";
import { domusoResponsiveStyleHelper } from "./utils/domuso-responsive";
import { BottomNav } from "../../components/layout/bottom-nav";
import { Footer } from "../../components/new/footer/footer";
import { Dropdown, Text, theme, typography } from "ui-components";
import { RewardsHeader } from "../../components/new/rewards/rewards-header";
import { translate } from "../../i18n";
import automationTestingLocators from "./utils/automation-testing-locators.json";
import { DropDownChoice } from "../../../types/components/dropdown";
import { convertHexToRGBA } from "../../utils/general";

export const RewardsHistory = () => {
  const yearDropdownItems: DropDownChoice[] = [
    { label: "2022", value: "2022", dbValue: "2022" },
    { label: "2023", value: "2023", dbValue: "2023" },
  ];
  const [selectedYearValue, setSelectedYearValue] = React.useState<any>("2023");

  const rewardHistoryData = [
    {
      rewardId: "1",
      type: "1",
      points: 100,
      pointsBalance: 600,
      status: "Pending",
      action: "Rent Paid on time",
      createdOn: new Date(selectedYearValue, 11, 6),
      claimedOn: new Date(selectedYearValue, 11, 6),
    },
    {
      rewardId: "2",
      type: "2",
      points: 700,
      pointsBalance: 700,
      status: "Earned",
      action: "Lease renewal",
      createdOn: new Date(selectedYearValue, 11, 6),
      claimedOn: new Date(selectedYearValue, 11, 6),
    },
    {
      rewardId: "3",
      type: "3",
      amount: 24,
      points: -1000,
      pointsBalance: 0,
      status: "Earned",
      action: "Claimed reward",
      createdOn: new Date(selectedYearValue, 11, 6),
      claimedOn: new Date(selectedYearValue, 11, 6),
    },
    {
      rewardId: "4",
      type: "4",
      points: 200,
      pointsBalance: 1000,
      status: "Earned",
      action: "Shown interest for lease renewal",
      createdOn: new Date(selectedYearValue, 11, 5),
      claimedOn: new Date(selectedYearValue, 11, 5),
    },
    {
      rewardId: "5",
      type: "5",
      points: 100,
      pointsBalance: 800,
      status: "Earned",
      action: "Rent Paid on time",
      createdOn: new Date(selectedYearValue, 11, 4),
      claimedOn: new Date(selectedYearValue, 11, 4),
    },
    {
      rewardId: "6",
      type: "6",
      points: 100,
      pointsBalance: 700,
      status: "Earned",
      action: "Rent Paid on time",
      createdOn: new Date(selectedYearValue, 11, 3),
      claimedOn: new Date(selectedYearValue, 11, 3),
    },
  ];

  return (
    <SafeAreaView style={styles.container}>
      <ScrollView style={styles.scrollView} contentContainerStyle={styles.scrollableArea}>
        <>
          <StatusBar
            hidden={false}
            translucent={false}
            backgroundColor={theme.colors.white}
            barStyle={"dark-content"}
          />
          <View style={styles.marginTop} />
          <Grid>
            <Container>
              <RewardsHeader
                testID="rewards-history"
                accessibilityLabel="rewards history"
                currentPoints="1,600"
                totalPoints="2,600"
              />

              <Row>
                <Column span={{ xs: false, sm: 2, md: 2, lg: 2 }} />
                <Column span={{ xs: 12, sm: 8, md: 8, lg: 8 }} style={styles.inputRow}>
                  <View style={styles.inputRowInner}>
                    <View style={styles.subHeaderContainer}>
                      <Text
                        style={styles.subHeaders}
                        {...automationTestingLocators.rewardsHistory.rewardsHistoryTitle}>
                        {translate("rewardsHistory.rewardsHistory")}
                      </Text>
                      <View style={{ width: Platform.OS == "android" ? 130 : 110 }}>
                        <Dropdown
                          pickerStyle={styles.dropdownPickerStyle}
                          textInputProps={{
                            sectionStyle: { borderRadius: 100 },
                            placeholderStyle: { paddingVertical: 10 },
                          }}
                          pickerItem={yearDropdownItems}
                          onValueChange={(value, index) => {
                            if (value != "selectAccountType") {
                              setSelectedYearValue(value);
                            }
                          }}
                          selectedValue={selectedYearValue}
                          pickerContainerStyle={styles.pickerContainerStyle}
                          {...automationTestingLocators.rewardsHistory.rewardsHistoryYearPicker}
                        />
                      </View>
                    </View>
                  </View>
                </Column>
                <Column span={{ xs: false, sm: 2, md: 2, lg: 2 }} />
              </Row>
              <Row>
                <Column span={{ xs: false, sm: 2, md: 2, lg: 2 }} />
                <Column span={{ xs: 12, sm: 8, md: 8, lg: 8 }} style={styles.inputRow}>
                  <View style={styles.inputRowInner}>
                    {rewardHistoryData?.map((item, index) => (
                      <View
                        style={[styles.cardStyle, { marginTop: index == 0 ? 10 : 16 }]}
                        id={item?.rewardId}
                        key={item?.rewardId || index}
                        testID={
                          automationTestingLocators.rewardsHistory.rewardsHistoryCard.testID +
                          `-${index}`
                        }
                        accessibilityLabel={
                          automationTestingLocators.rewardsHistory.rewardsHistoryCard
                            .accessibilityLabel + ` ${index}`
                        }>
                        <View style={styles.cardHeaderContainer}>
                          <Text
                            style={styles.cardHeaderTextStyle}
                            testID={
                              automationTestingLocators.rewardsHistory.rewardsHistoryCardDate
                                .testID + `-${index}`
                            }
                            accessibilityLabel={
                              automationTestingLocators.rewardsHistory.rewardsHistoryCardDate
                                .accessibilityLabel + ` ${index}`
                            }>{`${translate(
                            "rewardsHistory.date"
                          )}: ${item.createdOn.toLocaleDateString()}`}</Text>
                          <Text
                            style={styles.cardHeaderTextStyle}
                            testID={
                              automationTestingLocators.rewardsHistory.rewardsHistoryCardStatus
                                .testID + `-${index}`
                            }
                            accessibilityLabel={
                              automationTestingLocators.rewardsHistory.rewardsHistoryCardStatus
                                .accessibilityLabel + ` ${index}`
                            }>
                            {`${translate("rewardsHistory.status")}: `}
                            <Text
                              style={{
                                color:
                                  item.status == "Earned"
                                    ? theme.colors.success
                                    : theme.colors.warning,
                              }}>
                              {item.status}
                            </Text>
                          </Text>
                        </View>
                        <View style={styles.cardBodyContainer}>
                          <Text
                            style={styles.cardBodyTextStyle}
                            testID={
                              automationTestingLocators.rewardsHistory.rewardsHistoryCardAction
                                .testID + `-${index}`
                            }
                            accessibilityLabel={
                              automationTestingLocators.rewardsHistory.rewardsHistoryCardAction
                                .accessibilityLabel + ` ${index}`
                            }>
                            {`${translate("rewardsHistory.action")}: `}
                            <Text style={{ color: theme.colors.text3 }}>
                              {item?.action}
                              {item.amount && (
                                <Text
                                  style={{
                                    fontFamily: "Lato_700Bold",
                                  }}>{` $${item?.amount?.toFixed(2)}`}</Text>
                              )}
                            </Text>
                          </Text>
                        </View>
                        <View style={styles.cardFooterContainer}>
                          <View
                            style={{
                              flexDirection: "row",
                              alignItems: "center",
                              flexShrink: 1,
                              flex: 1,
                            }}>
                            <Text
                              style={styles.cardFooterPrimaryText}
                              testID={
                                automationTestingLocators.rewardsHistory
                                  .rewardsHistoryCardPointsText.testID + `-${index}`
                              }
                              accessibilityLabel={
                                automationTestingLocators.rewardsHistory
                                  .rewardsHistoryCardPointsText.accessibilityLabel + ` ${index}`
                              }>{`${translate("rewardsHistory.points")}: `}</Text>
                            <Text
                              style={[
                                styles.cardFooterSecondaryText,
                                {
                                  color:
                                    item?.points >= 0 ? theme.colors.success : theme.colors.alert,
                                },
                              ]}
                              testID={
                                automationTestingLocators.rewardsHistory.rewardsHistoryCardPoints
                                  .testID + `-${index}`
                              }
                              accessibilityLabel={
                                automationTestingLocators.rewardsHistory.rewardsHistoryCardPoints
                                  .accessibilityLabel + ` ${index}`
                              }>{`${
                              item?.points >= 0
                                ? "+" + item.points?.toLocaleString("en-US")
                                : item.points?.toLocaleString("en-US")
                            }`}</Text>
                          </View>
                          <View
                            style={{
                              flexDirection: "row",
                              alignItems: "center",
                              flexShrink: 1,
                              flex: 1,
                              justifyContent: "flex-end",
                            }}>
                            <Text
                              style={styles.cardFooterPrimaryText}
                              testID={
                                automationTestingLocators.rewardsHistory
                                  .rewardsHistoryCardPointsBalanceText.testID + `-${index}`
                              }
                              accessibilityLabel={
                                automationTestingLocators.rewardsHistory
                                  .rewardsHistoryCardPointsBalanceText.accessibilityLabel +
                                ` ${index}`
                              }>{`${translate("rewardsHistory.pointsBalance")}: `}</Text>
                            <Text
                              style={styles.cardFooterSecondaryText}
                              testID={
                                automationTestingLocators.rewardsHistory
                                  .rewardsHistoryCardPointsBalance.testID + `-${index}`
                              }
                              accessibilityLabel={
                                automationTestingLocators.rewardsHistory
                                  .rewardsHistoryCardPointsBalance.accessibilityLabel + ` ${index}`
                              }>{`${item?.pointsBalance?.toLocaleString("en-US")}`}</Text>
                          </View>
                        </View>
                      </View>
                    ))}
                  </View>
                </Column>
                <Column span={{ xs: false, sm: 2, md: 2, lg: 2 }} />
              </Row>
            </Container>
          </Grid>
        </>
      </ScrollView>

      <BottomNav backgroundColor={"#F5F5F5"}></BottomNav>
      <Footer />
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    ...domusoResponsiveStyleHelper({
      webPhone: {
        backgroundColor: "#F5F5F5",
      },
      webTablet: {
        backgroundColor: "#FAFAFA",
      },
      webDesktop: {
        backgroundColor: "#FAFAFA",
      },
      iosPhone: {
        backgroundColor: "#F5F5F5",
      },
      iosTablet: {
        backgroundColor: "#FAFAFA",
      },
      androidPhone: {
        backgroundColor: "#F5F5F5",
      },
      androidTablet: {
        backgroundColor: "#FAFAFA",
      },
    }),
  },
  scrollableArea: {
    ...domusoResponsiveStyleHelper({
      webPhone: { backgroundColor: "#F5F5F5", paddingBottom: 10 },
      webTablet: { backgroundColor: "#FAFAFA", paddingBottom: 10 },
      webDesktop: { backgroundColor: "#FAFAFA", paddingBottom: 10 },
      iosPhone: { backgroundColor: "#F5F5F5", paddingBottom: 200 },
      iosTablet: { backgroundColor: "#FAFAFA", paddingBottom: 10 },
      androidPhone: { backgroundColor: "#F5F5F5", paddingBottom: 200 },
      androidTablet: { backgroundColor: "#FAFAFA", paddingBottom: 10 },
    }),
  },
  scrollView: {
    flexGrow: 0,
  },
  marginTop: {
    ...domusoResponsiveStyleHelper({
      webTablet: { marginTop: 20 },
      webDesktop: { marginTop: 20 },
      iosTablet: { marginTop: 20 },
      androidTablet: { marginTop: 20 },
    }),
  },

  inputRow: {
    ...domusoResponsiveStyleHelper({
      webPhone: {},
      webTablet: {
        paddingLeft: 40,
        paddingRight: 40,

        backgroundColor: "#F5F5F5",

        borderLeftWidth: 1,
        borderLeftColor: "rgba(102, 102, 102, 0.1)",
        borderRightWidth: 1,
        borderRightColor: "rgba(102, 102, 102, 0.1)",
      },
      webDesktop: {
        paddingLeft: 40,
        paddingRight: 40,

        backgroundColor: "#F5F5F5",

        borderLeftWidth: 1,
        borderLeftColor: "rgba(102, 102, 102, 0.1)",
        borderRightWidth: 1,
        borderRightColor: "rgba(102, 102, 102, 0.1)",
      },
      iosPhone: {},
      iosTablet: {
        paddingLeft: 40,
        paddingRight: 40,

        backgroundColor: "#F5F5F5",

        borderLeftWidth: 1,
        borderLeftColor: "rgba(102, 102, 102, 0.1)",
        borderRightWidth: 1,
        borderRightColor: "rgba(102, 102, 102, 0.1)",
      },
      androidPhone: {},
      androidTablet: {
        paddingLeft: 40,
        paddingRight: 40,

        backgroundColor: "#F5F5F5",

        borderLeftWidth: 1,
        borderLeftColor: "rgba(102, 102, 102, 0.1)",
        borderRightWidth: 1,
        borderRightColor: "rgba(102, 102, 102, 0.1)",
      },
    }),
  },
  inputRowInner: {
    ...domusoResponsiveStyleHelper({
      webPhone: {},
      webTablet: {
        paddingLeft: 0,
        paddingRight: 0,
      },
      webDesktop: {
        paddingLeft: 30,
        paddingRight: 30,
      },
      iosPhone: {},
      iosTablet: {
        paddingLeft: 0,
        paddingRight: 0,
      },
      androidPhone: {},
      androidTablet: {
        paddingLeft: 0,
        paddingRight: 0,
      },
    }),
  },
  subHeaderContainer: {
    flex: 1,
    flexDirection: "row",
    marginTop: 32,
    alignItems: "center",
    justifyContent: "space-between",
    gap: 10,
  },
  subHeaders: {
    ...typography.title1,
    color: theme.colors.text4,
    fontWeight: "500",
    flex: 1,
  },
  cardStyle: {
    paddingHorizontal: 16,
    backgroundColor: "rgba(255, 255, 255, 0.5)",
    shadowOffset: { width: 0, height: 4 },
    shadowColor: "rgba(133, 133, 133, 0.15)",
    shadowOpacity: 1,
    shadowRadius: 32,
    elevation: 4,
    borderRadius: 10,
    marginTop: 16,
  },
  cardHeaderContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingTop: 12,
  },
  cardHeaderTextStyle: {
    ...typography.body,
    fontWeight: "400",
    color: theme.colors.secondary,
  },
  cardBodyContainer: {
    marginTop: 16,
  },
  cardBodyTextStyle: {
    ...typography.title2,
    fontWeight: "400",
    color: theme.colors.primary,
  },
  cardFooterContainer: {
    marginTop: 16,
    borderTopWidth: 0.5,
    borderTopColor: convertHexToRGBA(theme.colors.stroke, 0.5),
    paddingVertical: 12,
    marginHorizontal: -14,
    paddingHorizontal: 14,
    flexDirection: "row",
    justifyContent: "space-between",
    flex: 1,
    gap: 40,
  },
  cardFooterPrimaryText: {
    ...typography.body,
    fontWeight: "400",
    color: theme.colors.secondary,
  },
  cardFooterSecondaryText: {
    ...typography.title2,
    fontWeight: "600",
    color: theme.colors.success,
  },
  dropdownPickerStyle: {
    borderRadius: 200,
    width: "100%",
    height: "100%",
  },
  pickerContainerStyle: {
    borderRadius: 100,
    paddingHorizontal: 0,
    height: Platform.OS == "ios" ? "auto" : 40,
    flexDirection: "row",
    alignItems: "center",
  },
});
